import {
  HoobiizCartItemItemFull,
  SanitizedHoobiizOrderItemItem,
} from '@shared/api/definitions/public_api/hoobiiz_api';
import {Currency, CurrencyAmount} from '@shared/dynamo_model';
import {addCurrencyAmount, cents} from '@shared/lib/hoobiiz/currency_amount';
import {
  addDiscountedCurrencyAmount,
  baseDiscountedCurrencyAmount,
  computeCartItemPrice,
  DiscountedCurrencyAmount,
} from '@shared/lib/hoobiiz/discounted_currency_amount';

export const currencyToSymbol: Record<Currency, string> = {
  [Currency.Euro]: '€',
};

export function currencyAmountToString(amount: CurrencyAmount): string {
  return `${(amount.cents / 100).toLocaleString(undefined, {minimumFractionDigits: 2})} ${
    currencyToSymbol[amount.currency]
  }`;
}
export function currencyAmountToShortString(amount: CurrencyAmount): string {
  return `${(amount.cents / 100).toLocaleString(undefined)} ${currencyToSymbol[amount.currency]}`;
}

export function computeCartTotal(cartItems: HoobiizCartItemItemFull[]): {
  prices: DiscountedCurrencyAmount;
  fees: CurrencyAmount;
} {
  let prices = baseDiscountedCurrencyAmount(cents(0));
  let fees = cents(0);
  for (const item of cartItems) {
    const itemPrice = computeCartItemPrice(item);
    prices = addDiscountedCurrencyAmount(prices, itemPrice.prices);
    fees = addCurrencyAmount(fees, itemPrice.fees);
  }
  return {prices, fees};
}

export function computeOrderTotal(orders: SanitizedHoobiizOrderItemItem[]): {
  prices: DiscountedCurrencyAmount;
  fees: CurrencyAmount;
} {
  let prices = baseDiscountedCurrencyAmount(cents(0));
  let fees = cents(0);
  for (const item of orders) {
    const {price1, price2, price3, fees: itemFees} = item;
    prices = addDiscountedCurrencyAmount(prices, {price1, price2, price3});
    fees = addCurrencyAmount(fees, itemFees);
  }
  return {prices, fees};
}

export function compareCurrencyAmount(c1: CurrencyAmount, c2: CurrencyAmount): number {
  return c1.cents - c2.cents;
}
